import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import FetchHook from "../../../../Api/FetchHooks";
import TableComponent from "../../../../Components/TableComponent";
import { formatCurrencyV2, formatDate } from "../../../../utils/helpers";

const UserLoanReceipt = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [check, setCheck] = useState(0);

  const [loading, response, request] = FetchHook();

  useEffect(() => {
    if (check === 0) {
      request({
        url: `receipt?loan_instalment_detail_id='${location.state.id}'`,
      });
      setCheck(1);
    }
  }, [check]);

  const columns = [
    {
      field: "id",
      headerName: "Id",
      width: 150,
    },
    {
      field: "loan_instalment_detail_id",
      headerName: "Loan Instalment detail id",
      width: 150,
    },

    {
      field: "collected_amount",
      headerName: "Collected amount",
      width: 130,
      valueFormatter: (params) => formatCurrencyV2(params?.value),
    },
    {
      field: "instal_distribution_amount",
      headerName: "Instalment distribution amount",
      width: 150,
      valueFormatter: (params) => formatCurrencyV2(params?.value),
    },
    {
      field: "undistribution_bal",
      headerName: "Undistributed balance",
      width: 150,
      valueFormatter: (params) => formatCurrencyV2(params?.value),
    },
    {
      field: "description",
      headerName: "Description",
      flex: 1,
      minWidth: 300,
    },

    {
      field: "date_created",
      headerName: "Date created",
      width: 200,
      valueFormatter: (params) => formatDate(params?.value),
    },
    {
      field: "date_last_payment",
      headerName: "Last payment date",
      width: 200,
      valueFormatter: (params) => formatDate(params?.value),
    },
    {
      field: "distribution",
      headerName: "Distribution",
      width: 200,
      renderCell: (row) => (
        <Button
          variant="contained"
          onClick={() =>
            navigate(
              "/dashboard/users/user-profile/loan-instalments/loan-instalment-details/distribution",
              {
                state: {
                  loan_receipt: row.row,
                  loan_instalment_detail: location.state,
                },
              },
            )
          }
        >
          Distribution
        </Button>
      ),
    },
  ];

  return (
    <Box
      sx={{
        margin: "20px",
      }}
    >
      <Card>
        <CardHeader
          sx={{
            px: "30px",
          }}
          title={
            <Typography variant="h6">
              Loan Receipt (loan_instalment_detail_id: {location.state.id})
            </Typography>
          }
          action={
            <Box>
              <Button
                variant="contained"
                color="error"
                onClick={() => navigate(-1)}
              >
                Back
              </Button>
            </Box>
          }
        />
        <CardContent>
          {response && response.status === 200 ? (
            <TableComponent
              data={response.data.Receipt}
              columns={columns}
              loading={loading}
              sortModel={[
                {
                  field: "date_created",
                  sort: "desc",
                },
              ]}
            />
          ) : (
            <Grid>
              <CircularProgress />
            </Grid>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default UserLoanReceipt;
